export default __webpack_public_path__ + "static/media/mobile9.98812f35.jpg";